export default __webpack_public_path__ + "static/media/money1.e7a6a422.jpg";